import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * This component can be used to create a filter menu
 * @description It uses mat menu and content projection.
 * It has a reset filter button and apply filter button
 *
 * @example
 * <sp-extendable-filter-menu
 *   (clear)="resetFilter()"
 *   (apply)="applyFilter()"
 * >
 *  <sp-filter-menu-header>
 *    // filter menu header
 *  </sp-filter-menu-header>
 *  // filter menu content (form fields, etc.)
 * </sp-extendable-filter-menu>
 */
@Component({
  selector: 'sp-extendable-filter-menu',
  templateUrl: './extendable-filter-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendableFilterMenuComponent {
  /** Trigger filter button label  */
  @Input() buttonLabel = 'Filter';

  /** Trigger filter button label  */
  @Input() filterCounter = 0;

  /** reset filter button clicked */
  @Output() clear = new EventEmitter<void>();

  /** apply filter button clicked */
  @Output() apply = new EventEmitter<void>();

  /** close filter menu clicked */
  @Output() closed = new EventEmitter<void>();
}

/**
 * Filter menu header component
 * @description This component can be used to create a filter menu header
 * @example
 * <sp-filter-menu-header>
 * // filter menu header content
 * </sp-filter-menu-header>
 */
@Component({
  selector: 'sp-filter-menu-header',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendableFilterMenuHeaderComponent {}
